module.exports = __webpack_public_path__ + "img/scene4--after_3.svg";